import {State} from './reducer'

export const initialState: Omit<State, 'account'> = {
  showIbAccountPendingPopup: false,
}
